import type { ApolloClient } from '@apollo/client'
import type { FilterDefinition } from '@factorialco/f0-react/dist/experimental'
import { LegalEntitiesFilterDataDocument } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { createAsyncFilterWithQuery } from './createAsyncFilterWithQuery'

export const createLegalEntityIdsAsyncFilter = (
  apolloClient: ApolloClient<unknown>
): FilterDefinition =>
  createAsyncFilterWithQuery({
    label: i18n.t('expenses_v2.list.filters.label_legal_entity'),
    apolloClient,
    query: LegalEntitiesFilterDataDocument,
    variables: {},
    mapData: (data) => {
      const legalEntities = data?.companies?.legalEntitiesConnection?.nodes || []
      return legalEntities.map((entity) => ({
        label: entity.legalName || `Legal Entity ${entity.id}`,
        value: entity.id,
      }))
    },
  })
